export default "__VITE_PUBLIC_ASSET__394a7661__"